var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.logo},[(_vm.offer.redemptionImage)?_c('img',{attrs:{"src":_vm.offer.redemptionImage,"alt":_vm.offer.name}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }